import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DataService} from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadService extends DataService {

  private baseURI = this.apiUri + '/file';

  constructor(http: HttpClient) {
    super(http);
  }

  downloadFile(moduleName: string, fileName: string, scacCode: string): Observable<any> {
    this.setUri(this.baseURI + '/downloads');

    let params: HttpParams = new HttpParams();
    params = params.append('moduleName', moduleName);
    params = params.append('fileName', fileName);
    params = params.append('scacCode', scacCode);
    return this.get({
        params, responseType: 'blob',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Disposition': 'attachment'
        }
      }
    );
  }

  getPresignedUrl(moduleName: string, fileName: string, scacCode: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('moduleName', moduleName);
    params = params.append('fileName', fileName);
    params = params.append('scacCode', scacCode);
    return this.http.get(this.baseURI + '/getpresignedurl', {params: params});
  }

  downloadDocForSysAdmin(moduleName: string, fileName: string, scacCode: string): Observable<any> {
    this.setUri(this.baseURI + '/downloadsforsysadmin');

    let params: HttpParams = new HttpParams();
    params = params.append('moduleName', moduleName);
    params = params.append('fileName', fileName);
    params = params.append('scacCode', scacCode);
    return this.get({
        params, responseType: 'blob',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Disposition': 'attachment'
        }
      }
    );
  }

  getDownloadFilesList(): Observable<any> {
    this.setUri(this.baseURI + '/getdownloadfileslist');
    return this.get();
  }

  downloadFileForSysAdmin(scacCode: string): Observable<any> {
    this.setUri(this.baseURI + '/downloadfilesforsysadmin');
    let params: HttpParams = new HttpParams();
    params = params.append('scacCode', scacCode);
    return this.get({params});
/*     return this.get({params, responseType:  'blob',
        headers: {'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Disposition': 'attachment'}}
    ); */
  }
}
